// import Swiper from "swiper/bundle";
/* global Swiper: false */

export default class CustomSwiper {
	constructor(selector) {
		this.selector = selector;

		if (!this.selector) return;

		this.dataSettings = this.selector.dataset.swiper;

		const dataSettings =
			this.dataSettings &&
			this.dataSettings.length > 0 &&
			JSON.parse(this.dataSettings);

		const defaultSettings = {
			// Nelios custom setting
			arrowFade: false,
			// Optional parameters
			// direction: "vertical",
			// loop: true,
			// If we need pagination
			// pagination: {
			// 	el: ".swiper-pagination",
			// },
			// slidesPerView: 2.5,
			// Navigation arrows
			// navigation: {
			// 	nextEl: ".swiper-button-next",
			// 	prevEl: ".swiper-button-prev",
			// },
			// And if we need scrollbar
			// scrollbar: {
			// 	el: ".swiper-scrollbar",
			// },
		};

		this.settings = {
			...defaultSettings,
			...dataSettings,
		};

		if (document.querySelector(".list-card-items")) {
			this.settings = {
				...this.settings,
				...{
					on: {
						slideChange: function (swiper) {
							window.dispatchEvent(
								new CustomEvent("gmap.selectMarker", {
									detail: { realIndex: swiper.realIndex },
								})
							);
						},
						// afterInit: function (swiper) {
						// 	setTimeout(() => {
						// 		window.dispatchEvent(
						// 			new CustomEvent("gmap.selectMarker", {
						// 				detail: { realIndex: swiper.realIndex },
						// 			})
						// 		);
						// 	}, 1000);
						// },
					},
				},
			};
		}

		// console.log("Swiper settings:", this.settings);

		this.swiper = null;

		this.init();

		this.events();
	}

	init() {
		// const containers = document.querySelectorAll(this.selector);

		// containers.forEach((container) => {
		// const slides = container.querySelector(".swiper");
		// const clickPrev = container.querySelectorAll(".click-prev");
		// const clickNext = container.querySelectorAll(".click-next");
		// const numberCurrent = container.querySelector(".number-current");

		this.swiper = new Swiper(this.selector, this.settings);

		if (this.settings.arrowFade)
			this.swiper.el.classList.add("swiper-with-arrow-fade");

		// clickPrev.forEach((button) => {
		// 	button.addEventListener("click", (e) => {
		// 		e.preventDefault();
		// 		swiper.slidePrev();
		// 	});
		// });

		// clickNext.forEach((button) => {
		// 	button.addEventListener("click", (e) => {
		// 		e.preventDefault();
		// 		swiper.slideNext();
		// 	});
		// });

		this.swiper.on("slideChange", function () {

			if (!window.matchMedia("(max-width: 1200px)").matches){

				if (this.el.classList.contains('swiper-snap-first')) {
					if (this.activeIndex === 0) {
						this.slideTo(1);
					}
				}
				if (this.el.classList.contains('swiper-snap-last')) {
					if (this.activeIndex === this.slides.length - 1) {
						this.slideTo(this.slides.length - 2);
					}
				}
			}



		});
		// });
	}

	update() {
		this.swiper.update();
	}

	events() {
		if (this.swiper && this.settings.arrowFade && window.innerWidth >= 1024) {
			const prevEl = Array.isArray(this.swiper.navigation.prevEl)
				? this.swiper.navigation.prevEl[0]
				: this.swiper.navigation.prevEl;
			const nextEl = Array.isArray(this.swiper.navigation.nextEl)
				? this.swiper.navigation.nextEl[0]
				: this.swiper.navigation.nextEl;
			// console.log(prevEl, nextEl);
			this.swiper.el.addEventListener("mousemove", (ev) => {
				const rate = 1 / 3;
				const clickTarget = ev.currentTarget;
				const clickTargetWidth = clickTarget.offsetWidth;
				const xCoordInClickTarget =
					ev.clientX - clickTarget.getBoundingClientRect().left;

				// console.log(clickTargetWidth, xCoordInClickTarget);

				if (xCoordInClickTarget < clickTargetWidth / (1 / rate)) {
					// left
					prevEl.classList.add("active");
				} else if (xCoordInClickTarget > clickTargetWidth * (1 - rate)) {
					// right
					nextEl.classList.add("active");
				} else {
					nextEl.classList.remove("active");
					prevEl.classList.remove("active");
				}
			});
		}
	}
}
